import { render, staticRenderFns } from "./UtilLoader.vue?vue&type=template&id=70c8fb76&scoped=true&"
import script from "./UtilLoader.vue?vue&type=script&lang=js&"
export * from "./UtilLoader.vue?vue&type=script&lang=js&"
import style0 from "./UtilLoader.vue?vue&type=style&index=0&id=70c8fb76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c8fb76",
  null
  
)

export default component.exports